<template>
  <div class="wrapper">
    <div class="noneCard" v-if="showIF">
      <img src="@/assets/record/empty.png" />
      <span>暂无电子健康卡</span>
    </div>
    <ul class="kabao" v-if="!showIF" v-for="item in allCards" :key="item.carId">
      <li class="info">
        <div>
          <span>{{ item.patientname }}</span>
          <span>{{ item.sex }}</span>
          <span>{{ item.age }}岁</span>
          <span class="give" v-if="item.style == 1?true:false">当前默认</span>
        </div>
        <div>
          <span>身份证</span>
          <span>{{
            item.idcardno.replace(/(\w{4})\w*(\w{4})/, "$1******$2")
          }}</span>
        </div>
        <img src="@/assets/record/jkm.png" @click="cardbtn(item)"/>
      </li>
      <li class="btns" v-if="item.style == 1?false:true">
        <van-button type="primary" size="mini" round @click="selbtn(item)" v-if="item.style == 1?false:true">设置默认</van-button>
        <van-button type="danger" size="mini" round @click="delbtn(item)"
          >删除</van-button
        >
      </li>
    </ul>
    <van-button type="info" round size="large" @click="JumpAdd"
      >添加</van-button
    >
    <!-- <span class="relation">您还可以添加{{ 5-allCards.length }}张电子健康卡</span> -->
    <judgment></judgment>
  </div>
</template>

<script>
import { selectVisitinfos, delCard, setStyle } from "@/request/api.js";
import Judgment from "@/components/Judgment/Judgment.vue";
import { Dialog } from "vant";
export default {
  components: {
    Judgment
  },
  data() {
    return {
      showIF: true,
      allCards: []
    };
  },
  async mounted() {
    this.handleQuery()
  },
  methods: {
    async handleQuery(){
      let openid = sessionStorage.getItem("openid");
      let res = await selectVisitinfos({ openid });
      this.allCards = res.data.obj;
      if (this.allCards.length == 0) {
        this.showIF = true;
      } else {
        this.showIF = false;
      }
      this.allCards.forEach(item => {
        if (item.style == 1) {
          sessionStorage.setItem("card", JSON.stringify(item));
        }
      });
    },
    JumpAdd() {
      this.$router.push("/AddVisitors");
    },
    async getList() {
      let openid = sessionStorage.getItem("openid");
      let res = await selectVisitinfos({ openid });
      this.allCards = res.data.obj;
      if (this.allCards.length != 0) {
        this.showIF = true;
      }
    },
    // 默认卡设置
    selbtn(it){
      let map = {
        carId: it.carId,
        openid: sessionStorage.getItem("openid")
      }
      Dialog.alert({
        message: "是否把此卡设置为默认卡",
        showCancelButton: "true"
      })
        .then(async () => {
          let res = await setStyle(map);
          if(res.data.message == "操作成功"){
            this.Toast.success('操作成功');
            this.handleQuery();
          } else {
            this.Toast.fail('操作失败');
          }
        })
        .catch(() => {});
    },
    // 健康卡
    cardbtn(item){
      sessionStorage.setItem("card", JSON.stringify(item));
      this.$router.push("/HealthCard");
    },
    // 删除卡
    delbtn(it) {
      Dialog.alert({
        message: "是否要删除该就诊卡",
        showCancelButton: "true"
      })
        .then(async () => {
          let res = await delCard(it.carId);
          if(res.data.message == "操作成功"){
            this.Toast.success('删除成功');
            this.handleQuery();
          } else {
            this.Toast.fail('删除失败');
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f7f7f9;
  .noneCard {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    margin-bottom: 40px;
    > img {
      width: 130px;
      margin: 100px 0px 20px;
    }
    > span {
      letter-spacing: 2px;
      font-size: 14px;
    }
  }
  .kabao {
    margin: 10px 10px 20px;
    background: #fff;
    display: flex;
    flex-flow: column nowrap;
    .info {
      border-bottom: 1px solid #eee;
      padding: 10px 10px 0px;
      position: relative;
      font-size: 14px;
      > div {
        margin-bottom: 10px;
        > span {
          margin-right: 10px;
        }
        .give {
          background: #399acd;
          padding: 1px 5px;
          color: #fff;
          border-radius: 2px;
        }
      }
      > img {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 28px;
      }
    }
    /deep/ .btns {
      padding: 10px;
      text-align: right;
      .van-button--danger {
        width: 60px;
        background: #ef7b48;
        border: #ef7b48;
      }
      .van-button--mini {
        width: 60px;
      }
    }
  }
  /deep/ .van-button--info {
    width: 355px;
    margin: 0px 10px;
    background: #399fd0;
  }
  .relation {
    display: block;
    text-align: center;
    margin-top: 20px;
    letter-spacing: 1px;
    color: #82cae3;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/EstablishArchives/MedicalCard.vue